var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.887,
    height: 30.887,
    viewBox: "0 0 30.887 30.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25329",
    "data-name": "Path 25329",
    d: "M11.627,37.839a7.71,7.71,0,0,1-5.4-2.239,7.573,7.573,0,0,1,0-10.81l5.554-5.56a7.554,7.554,0,0,1,10.8,0,1.544,1.544,0,0,1-2.16,2.162,4.625,4.625,0,0,0-6.48,0l-5.554,5.56a4.584,4.584,0,1,0,6.48,6.486l3.471-3.629a1.544,1.544,0,0,1,2.16,2.162L17.027,35.6a7.71,7.71,0,0,1-5.4,2.239Z",
    transform: "translate(0.041 -2.953)",
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25330",
    "data-name": "Path 25330",
    d: "M25.208,24.849a7.71,7.71,0,0,1-5.4-2.239,1.544,1.544,0,0,1,2.16-2.162,4.625,4.625,0,0,0,6.48,0L34,14.888A4.584,4.584,0,1,0,27.522,8.4l-3.471,3.629a1.544,1.544,0,0,1-2.16-2.162l3.471-3.629a7.64,7.64,0,1,1,10.8,10.811l-5.554,5.559A7.71,7.71,0,0,1,25.208,24.849Z",
    transform: "translate(-3.512 0)",
    fill: "#E6E7EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.1d26d873251776edcc5a08c5384a930d.svg";
export { ForwardRef as ReactComponent };